import { lazy, Suspense } from 'react';

const RichNoteEditor = lazy(() => import('./RichNoteEditor'));

// Code-split wrapper: TipTap + ProseMirror only download the first time a comment
// box is opened, not with the app shell. Same props as RichNoteEditor.
export default function RichNoteEditorLazy(props) {
  return (
    <Suspense
      fallback={
        <div className="note-editor">
          <div style={{ padding: '11px 12px', fontSize: 13, color: 'var(--muted)' }}>Loading editor…</div>
        </div>
      }
    >
      <RichNoteEditor {...props} />
    </Suspense>
  );
}
